import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { ProjectsApiService } from '../features/projects/domain/infrastructure/projects-api.service';
import { EditorWarmup } from './editor-warmup';

// Router runs loadComponent only after guards+resolvers: start editor chunk + WASM here, in parallel with them.
export const editorPrefetchGuard: CanActivateFn = route => {
  const projectId = route.paramMap.get('projectId');
  const albumId = route.paramMap.get('albumId');
  performance.mark(`editor-boot-start:${projectId}/${albumId}`);
  inject(EditorWarmup).warm();
  // The open reads the project from several ports and again after the load: one answer serves them all.
  if (projectId) inject(ProjectsApiService).holdProjectDetail(projectId);

  return true;
};
